import { Pipe, PipeTransform } from "@angular/core";
import { KeycloakHelperService } from "@core/services";

function formatCurrency(
  locale: string,
  currency: string,
  value: number,
  removeCurrencySymbol = false
) {
  let currencySymbol = "";
  if (removeCurrencySymbol) {
    currencySymbol = currency;
  }
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency
  })
    .format(value)
    .replace(currencySymbol, "")
    .trim();
}

type CurrencySymbol = "removeCurrencySymbol";

@Pipe({
    name: "currencyFormat",
    standalone: false
})
export class CurrencyFormatPipe implements PipeTransform {
  constructor(private keycloakHelperService: KeycloakHelperService) {}

  transform(value: number, currencySymbol?: CurrencySymbol): string | number {
    if (value === null || value === undefined || typeof value !== "number") {
      return value;
    }

    const removeCurrencySymbol = currencySymbol === "removeCurrencySymbol";

    if (this.keycloakHelperService.isBrazilian()) {
      return formatCurrency("pt-BR", "BRL", value, removeCurrencySymbol);
    }

    if (this.keycloakHelperService.isArgentinian()) {
      return formatCurrency("es-AR", "ARS", value, removeCurrencySymbol);
    }

    return formatCurrency("en-US", "USD", value, removeCurrencySymbol).replace(
      /(\$)(\d)/g,
      "$1 $2"
    );
  }
}
